/**
 * True when the page is served from a loopback host (typical local dev server).
 * Matches the same rules as registerServiceWorker.js, plus *.localhost.
 */
export function isLocalhostHostname(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "[::1]" ||
    hostname.endsWith(".localhost") ||
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/.test(hostname)
  );
}

export function isRunningOnLocalhost(): boolean {
  return typeof window !== "undefined" && isLocalhostHostname(window.location.hostname);
}
